// extracted by mini-css-extract-plugin
export default {"ourWork":"OurWorkContainer-module_ourWork__KxbrX"};